import { createContext } from 'react';

export const RadioContext = createContext<{
  currentValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}>({
  currentValue: '',
  onChange: () => {},
});
